import { Cascader, Modal } from 'antd';
import { useState } from 'react';

interface Props {
  categoryOptions: any[];
  onClose: () => void;
  onChange: (categoryId: string) => void;
}
const TransferClass: React.FC<Props> = (props: Props) => {
  const { categoryOptions, onClose, onChange } = props;
  const [categoryId, setCategoryId] = useState('');

  const onCategoryChange = (values: any[]) => {
    if (!values || values.length === 0) {
      setCategoryId('');
      return;
    }
    setCategoryId(values[values.length - 1]);
  };
  const onSubmit = () => {
    onChange(categoryId);
  };
  return (
    <Modal
      visible={true}
      width={416}
      title="转移分类"
      maskClosable={false}
      onOk={onSubmit}
      onCancel={onClose}
      okButtonProps={{ disabled: !categoryId }}
      style={{ top: 200 }}
    >
      <div>
        <div style={{ fontSize: '14px', color: '#5F6173', marginBottom: '12px' }}>
          删除分类，需将分类下的构件转移至其它分类
        </div>
        <Cascader
          // changeOnSelect
          placeholder="请选择分类"
          expandTrigger="hover"
          style={{ width: '100%', maxWidth: '330px' }}
          options={categoryOptions}
          onChange={onCategoryChange}
        ></Cascader>
      </div>
    </Modal>
  );
};

export default TransferClass;
